module.exports = __webpack_public_path__ + "static/media/Book-Appointment-Icon-Red.44a52e65.svg";